import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { UUID, VehicleGroup } from '@cobliteam/common-types';
import type { StateCreator } from 'zustand';
import SectionType from '../../types/SectionType';
import SortType from '../../types/SortType';
import type { MonitoringSlices } from '.';

interface DevicesListFilters {
  sectionTypeFilter: SectionType;
  vehiclesFilter: UUID[];
  vehicleGroupsFilter: VehicleGroup[];
  searchBoxFilter: string;
  sortFilter: SortType;
}

interface DevicesListSlice {
  devicesListFilters: DevicesListFilters;
  showUnpluggedDialog: boolean;
  showObservationDialog: boolean;
  deviceToReportProblem?: DeviceFragment;
  setDevicesListFilters: (filters: Partial<DevicesListFilters>) => void;
  clearDevicesListFilters: () => void;
  setDeviceToReportProblem: (props?: DeviceFragment) => void;
  setShowUnpluggedDialog: (show: boolean) => void;
  setShowObservationDialog: (show: boolean) => void;
}

type StateCreatorDevicesList = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], DevicesListSlice>;

const createDevicesListSlice: StateCreatorDevicesList = (set) => ({
  devicesListFilters: {
    sectionTypeFilter: SectionType.PLUGGED,
    vehiclesFilter: [],
    vehicleGroupsFilter: [],
    searchBoxFilter: '',
    sortFilter: SortType.ON,
  },
  showUnpluggedDialog: false,
  showObservationDialog: false,
  setDevicesListFilters: (filters: Partial<DevicesListFilters>) =>
    set((state) => ({
      devicesListFilters: { ...state.devicesListFilters, ...filters },
    })),
  clearDevicesListFilters: () =>
    set(() => ({
      devicesListFilters: {
        sectionTypeFilter: SectionType.PLUGGED,
        vehiclesFilter: [],
        vehicleGroupsFilter: [],
        searchBoxFilter: '',
        sortFilter: SortType.ON,
      },
    })),
  setShowUnpluggedDialog: (showUnpluggedDialog: boolean) => set({ showUnpluggedDialog }),
  setDeviceToReportProblem: (device?: DeviceFragment) => set({ deviceToReportProblem: device }),
  setShowObservationDialog: (showObservationDialog: boolean) => set({ showObservationDialog }),
});

export type { DevicesListFilters, DevicesListSlice };
export default createDevicesListSlice;
